import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type2LinkUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type2Link", configService);
    }
}
